module.exports = __webpack_public_path__ + "static/media/solution 26.32f3317d.jpg";